$('.js-toggle').on('click', (e) => {
  $(e.currentTarget).toggleClass('is_active')
  $(e.currentTarget).next().slideToggle(200)
})
